import React, { Component } from 'react'
import { connectStateResults } from 'react-instantsearch-dom'

class State extends Component {
  constructor(props) {
    super(props)
  }

  componentDidUpdate(prevProps) {
    const { allSearchResults, results, changeResultsAmount, index } = this.props

    if (
      allSearchResults &&
      allSearchResults[`${index.products}`] &&
      allSearchResults[`${index.articles}`] &&
      allSearchResults[`${index.pages}`] &&
      !this.props.searching
    ) {
      if (
        allSearchResults[`${index.products}`].nbHits !==
          results.productResults ||
        allSearchResults[`${index.articles}`].nbHits !==
          results.articleResults ||
        allSearchResults[`${index.pages}`].nbHits !== results.pageResults
      ) {
        changeResultsAmount({
          productResults: allSearchResults[`${index.products}`].nbHits,
          articleResults: allSearchResults[`${index.articles}`].nbHits,
          pageResults: allSearchResults[`${index.pages}`].nbHits,
        })
      }
    }
  }

  render() {
    return null
  }
}

const StateResults = connectStateResults(State)

export default StateResults
